import React from "react";
import { Button } from "@/components/ui/button";
import { Section, Hint } from "./SettingsShared";
import WalletConnect from "./WalletConnect";
import FaucetCard from "./FaucetCard";

const FundingTab = ({ user, refreshUser }) => (
  <Section
    title="Payment methods"
    description="Fund escrow and claim payments with a connected crypto wallet."
    data-testid="funding-section"
  >
    <WalletConnect user={user} refreshUser={refreshUser} />

    <div className="pt-5 mt-2 space-y-3 border-t border-border">
      <div className="flex items-center gap-2">
        <span className="font-display font-semibold">Cards</span>
        <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-full bg-secondary text-muted-foreground">
          Coming soon
        </span>
      </div>
      <div className="p-6 text-sm text-center border border-dashed rounded-lg border-border text-muted-foreground" data-testid="cards-coming-soon">
        Card payments aren't available yet — fund with a crypto wallet above.
      </div>
      <Button variant="outline" disabled data-testid="add-card-btn">
        + Add card
      </Button>
      <Hint>We'll enable card funding once fiat on-ramp support lands.</Hint>
    </div>

    <FaucetCard user={user} />
  </Section>
);

export default FundingTab;
